import { render, staticRenderFns } from "./comp6-3.vue?vue&type=template&id=3cb4c58a&scoped=true"
import script from "./comp6-3.vue?vue&type=script&lang=ts"
export * from "./comp6-3.vue?vue&type=script&lang=ts"
import style0 from "./comp6-3.vue?vue&type=style&index=0&id=3cb4c58a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb4c58a",
  null
  
)

export default component.exports